<div [attr.data-qa-id]="title" class="mb-2">
  <h4 class="title is-4 mt-6">{{ title }}</h4>
  <app-address-inputs [form]="addressForm" [multiregion]="false"></app-address-inputs>
  <div *ngIf="hint" class="mt-4 hint" data-qa-id="Address hint">{{ hint }}</div>
  <div *ngIf="displayAddressStateError" class="mt-4 error" data-qa-id="Address State Error">
    IMPORTANT: You must enter an address in the same state as your selected pharmacy. You will never receive mail at
    this address. If you are traveling, feel free to provide a temporary address.
  </div>
</div>
